var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.to ? 'NuxtLink' : 'span',{tag:"component",class:[
    'ucrs-anchor',
    {
      'ucrs-anchor--disabled': _vm.disabled,
      'ucrs-anchor--reverse': _vm.iconPosition == 'left',
      'ucrs-anchor--animation': _vm.animation == true,
    },
  ],attrs:{"to":_vm.to ? _vm.to : null},on:{"click":function($event){return _vm.$emit('click')}},nativeOn:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"ucrs-anchor__text",class:[`ucrs-anchor__text--${_vm.fontSize}`]},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]),_vm._v(" "),_c('SvgIcon',{class:[
      'ucrs-anchor__icon',
      `ucrs-anchor__icon--${_vm.iconSize}`,
      {
        'ucrs-anchor__icon--left': _vm.iconPosition == 'left',
        'ucrs-anchor__icon--right': _vm.iconPosition == 'right',
        'ucrs-anchor__icon--disabled': _vm.disabled,
      },
    ],attrs:{"name":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }